<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/11ai36j/tc-custom/9781460386804.jpg?1725275240499" alt="This image is the cover for the book Royal Temptation, Dynasties: The Montoros"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Royal Temptation, Dynasties: The Montoros
      </h1>
      <p class="bookDescription body article font2">
        <b>An American businessman becomes king and falls in love at first sight in this shocking royal romance by a <i>USA Today</i>–bestselling author.</b><br/><br/>Juan Carlos Salazar II never thought he’d become King of Alma. But when an explosive family secret leaves him next in line for the throne, he’s ready.<br/><br/>Until he catches a glimpse of Princess Portia Lindstrom at the coronation. Because it’s love at first sight with this mysterious woman. But Portia’s secrets test the power of his devotion and Juan Carlos is tempted to throw duty out the window. Sorely tempted.<br/><br/>Soon he must choose between commitment to country and family . . . or his own heart.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Charlene Sands
      </h2>
      
      <p class="authorDescription body article">Charlene Sands is a USA Today bestselling author of 35&#160;contemporary and historical romances. She&#39;s&#160;been honored with The National Readers&#39; Choice Award,&#160;Booksellers Best Award and Cataromance Reviewer&#39;s Choice Award.&#160;She loves babies,chocolate and&#160;thrilling love stories.Take a peek at her&#160;bold,&#160;sexy&#160;heroes and<I>&#160;real good men!</I>&#160;&#160;<a href="http://www.charlenesands.com">www.charlenesands.com</a>&#160;&#160;and Facebook</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?fc3d36ac